<template>
  <div class="cfdi-online-benefits">
    <div class="columns is-multiline is-flex-mobile">
      <div
        v-for="benefit in benefits"
        :key="benefit.icon"
        class="column is-3 is-6-mobile is-flex"
      >
        <BIcon
          class="benefit-icon"
          :icon="benefit.icon"
        />
        <div class="title is-5 has-text-white has-text-centered">
          {{ benefit.title }}
        </div>
        <div class="title is-6 has-text-white has-text-centered">
          {{ benefit.subtitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CfdiOnlineBenefits',
  data() {
    return {
      benefits: [
        {
          icon: 'file',
          title: 'Prefacturas',
          subtitle: `
            Previsualiza y valida con tus
              clientes antes de timbrar
          `,
        },
        {
          icon: 'sync',
          title: 'Autofactura',
          subtitle: `
            Tus clientes generan su
              factura cuando quieran
          `,
        },
        {
          icon: 'wallet',
          title: 'Complementos de pago',
          subtitle: `
            De acuerdo a la regulación del SAT
              para las facturas PPD
          `,
        },
        {
          icon: 'calendar-range',
          title: 'Recibos de nómina',
          subtitle: `
            Para todos tus empleados
          `,
        },
        {
          icon: 'account-box',
          title: 'Catálogo de empleados',
          subtitle: `
            Carga masivamente la información
              de tus empleados
          `,
        },
        {
          icon: 'receipt',
          title: 'Notas de remisión',
          subtitle: `
            Olvídate de los blocks impresos
          `,
        },
        {
          icon: 'file-document',
          title: 'Recibo de salario',
          subtitle: `
            Si no emites recibos de nómina
              esta es tu opción
          `,
        },
        {
          icon: 'chart-bar',
          title: 'Reporte de ventas',
          subtitle: `
            Visualiza el comportamiento
              de tus ventas
          `,
        },
      ],
    };
  },
};
</script>

<style scoped>
.columns {
  min-height: 400px;
}

.column.is-flex {
  flex-direction: column;
  align-items: center;
}

.title.is-5 {
  margin-top: 1.5rem;
}

.title.is-6 {
  margin-bottom: .5rem;
}
</style>

<style>
.cfdi-online-benefits .benefit-icon .mdi:before {
  width: 55px;
  height: 55px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
